import React, { Component } from 'react'
import { Box, CustomizedErrorMessage } from '../../styles.style'

class DocumentUsername extends Component {
	constructor(props) {
		super(props)
		this.state = {
			usernameError: ''
		}
	}

	nextPage = () => {
		this.props.handleSetUsername(this.props.values.username)
		this.props.nextStep()
	}

	handleCompleteUsernameField = () => {
		const username = this.props.values.username
		let errorMessage = ''

		const namePattern = /^(?=.*\s).{2,}$/

		if (!username) {
			errorMessage = 'Informe o nome de usuário'
		} else if (!namePattern.test(username)) {
			errorMessage = 'O nome de usuário deve conter pelo menos duas palavras'
		}

		this.setState({ usernameError: errorMessage })
	}

	render() {
		const { setFieldValue, errors, touched, values } = this.props
		const { usernameError } = this.state

		const isDisabled =
			!values.username ||
			usernameError ||
			(errors.username && touched.username)

		return (
			<Box>
				<div className="field">
					<header>
						<h5>Informe seu nome de usuário</h5>
					</header>
					<input
						id="username"
						name="username"
						type="text"
						placeholder="Nome de usuário"
						value={values.username}
						onChange={e => {
							setFieldValue('username', e.target.value)
						}}
						onBlur={this.handleCompleteUsernameField}
					/>
					{usernameError && (
						<CustomizedErrorMessage>
							{usernameError}
						</CustomizedErrorMessage>
					)}
				</div>
				<footer className="footer">
					<button
						className="button transparent"
						type="button"
						onClick={() => this.props.prevStep()}>
						Voltar
					</button>
					<button
						disabled={isDisabled}
						className={isDisabled ? 'disabled button' : 'button'}
						type="button"
						onClick={() => this.nextPage()}>
						Próximo
					</button>
				</footer>
			</Box>
		)
	}
}

export default DocumentUsername
